const buildLibraryCompareFrom = (hrisName) => ({
  'draft-job-profiles': {
    backTo: { name: 'draft-job-profiles' },
    label: 'Draft Job Profiles',
  },
  'hris-job-profiles': {
    backTo: { name: 'hris-job-profiles' },
    label: `${hrisName} Job Profiles`,
  },
  'job-architecture': {
    backTo: { name: 'job-architecture', query: { view: 'list' } },
    label: 'Job Architecture',
  },
});

const buildEditorCompareFrom = (hrisName) => ({
  'job-profile-view': {
    label: 'Draft Job Profile',
  },
  'job-profile-hris-view': {
    label: `${hrisName} Job Profile`,
  },
});

const EDITOR_COMPARE_FROM_KEYS = ['job-profile-view', 'job-profile-hris-view'];

export const isEditorCompareFrom = (from) => EDITOR_COMPARE_FROM_KEYS.includes(from);

// Pick the compare page back link. If we came from an editor with an id, go back there.
export const resolveCompareBreadcrumb = ({
  from,
  fromId,
  hrisUlids = [],
  draftUlids = [],
  hrisName,
} = {}) => {
  const libraryCompareFrom = buildLibraryCompareFrom(hrisName);
  const editorCompareFrom = buildEditorCompareFrom(hrisName);

  if (isEditorCompareFrom(from) && fromId) {
    return {
      from,
      label: editorCompareFrom[from].label,
      backTo: {
        name: from,
        params: { id: fromId },
      },
    };
  }

  const noSelection = hrisUlids.length === 0 && draftUlids.length === 0;

  if (noSelection) {
    const fallbackFrom = libraryCompareFrom[from] ? from : 'job-architecture';

    return {
      from: fallbackFrom,
      ...libraryCompareFrom[fallbackFrom],
    };
  }

  const isDraftOnly = hrisUlids.length === 0 && draftUlids.length > 0;
  const isHrisOnlyFromLibrary = hrisUlids.length > 0
    && draftUlids.length === 0
    && from === 'hris-job-profiles';

  let resolvedFrom = 'job-architecture';

  if (isDraftOnly) resolvedFrom = 'draft-job-profiles';
  else if (isHrisOnlyFromLibrary) resolvedFrom = 'hris-job-profiles';

  return {
    from: resolvedFrom,
    ...libraryCompareFrom[resolvedFrom],
  };
};
